import Icon from "@ant-design/icons";

const Svg = ({isActive = false}:any) => {

  const commonSvg = (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M26 13.0063C26 20.1679 20.1651 26 13 26C5.83494 26 0 20.1679 0 13.0063C0 5.83213 5.83494 0 13 0C20.1651 0 26 5.83213 26 13.0063Z"
        fill="#00BDF4"/>
      <path
        d="M18.2001 13.0063C18.2001 13.3349 18.0967 13.6647 17.8899 13.9288C17.8511 13.9806 17.6701 14.1942 17.5279 14.3332L17.4504 14.409C16.3646 15.5602 13.663 17.2914 12.2929 17.8462C12.2929 17.8588 11.4785 18.1886 11.0907 18.2H11.039C10.4444 18.2 9.88859 17.8727 9.60422 17.342C9.4491 17.0501 9.30692 16.2034 9.29399 16.192C9.17765 15.4326 9.1001 14.27 9.1001 12.9937C9.1001 11.6555 9.17765 10.4411 9.31984 9.69551C9.31984 9.68287 9.46203 9.00049 9.55251 8.77303C9.6947 8.44574 9.95322 8.16647 10.2764 7.98955C10.5349 7.86445 10.8063 7.8 11.0907 7.8C11.388 7.8139 11.9438 8.00219 12.1636 8.09065C13.6113 8.64666 16.3775 10.4663 17.4375 11.5784C17.6184 11.7553 17.8123 11.9714 17.864 12.0207C18.0838 12.2987 18.2001 12.6399 18.2001 13.0063Z"
        fill="white"/>
    </svg>
  )

  const activeSvg = (
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M26 13.0063C26 20.1679 20.1651 26 13 26C5.83494 26 0 20.1679 0 13.0063C0 5.83213 5.83494 0 13 0C20.1651 0 26 5.83213 26 13.0063Z"
        fill="#FF9500"/>
      <path
        d="M18.2001 13.0063C18.2001 13.3349 18.0967 13.6647 17.8899 13.9288C17.8511 13.9806 17.6701 14.1942 17.5279 14.3332L17.4504 14.409C16.3646 15.5602 13.663 17.2914 12.2929 17.8462C12.2929 17.8588 11.4785 18.1886 11.0907 18.2H11.039C10.4444 18.2 9.88859 17.8727 9.60422 17.342C9.4491 17.0501 9.30692 16.2034 9.29399 16.192C9.17765 15.4326 9.1001 14.27 9.1001 12.9937C9.1001 11.6555 9.17765 10.4411 9.31984 9.69551C9.31984 9.68287 9.46203 9.00049 9.55251 8.77303C9.6947 8.44574 9.95322 8.16647 10.2764 7.98955C10.5349 7.86445 10.8063 7.8 11.0907 7.8C11.388 7.8139 11.9438 8.00219 12.1636 8.09065C13.6113 8.64666 16.3775 10.4663 17.4375 11.5784C17.6184 11.7553 17.8123 11.9714 17.864 12.0207C18.0838 12.2987 18.2001 12.6399 18.2001 13.0063Z"
        fill="white"/>
    </svg>
  )


  console.log("isActive",isActive)

  return isActive ? activeSvg : commonSvg
}
export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;